export function formatTextWithParagraph(text) {
	if (!text) return '';

	const lines = text.split('\n');
	let html = '';
	let isListCreated = false;

	lines.forEach(line => {
		const trimmedLine = line.trim();

		if (trimmedLine.startsWith('-')) {
			if (!isListCreated) {
				html += '<ul>';
				isListCreated = true;
			}

			const cleanedTrimmedLine = trimmedLine.replace('-', '').trim();
			html += `<li>${cleanedTrimmedLine}</li>`;
		} else {
			if (isListCreated) {
				html += '</ul>';
				isListCreated = false;
			}

			if (trimmedLine) {
				html += `<p>${trimmedLine}</p>`;
			}
		}
	});

	if (isListCreated) {
		html += '</ul>';
	}

	return html;
}

export function cutTextBy(numberOfCharacters, text) {
	if (text <= numberOfCharacters) return text;

	return text.slice(0, numberOfCharacters - 3) + '...';
}